module.exports = __webpack_public_path__ + "static/media/ImgPDF.66dab1bb.svg";